export const LIST_REQUESTS = "listRequests";
export const GET_REQUEST = "getRequest";
export const CREATE_REQUEST = "createRequest";
